import FailedOrders from "../symbols/failedOrders";
import { HttpRequestPost } from "../../service";
import { roleName } from "../../utils/roles";
export interface IOrderFilter {
  Shop?: string[];
  Status: string[];
  DateRange?: string[];
}
type GetOrdersRequestModel = {
  Filter: IOrderFilter;
  OrderBy: string;
  Query: string;
  Page: number;
  Size: number;
};
const failedOrdersAction = () => ({
  type: FailedOrders.FAILED_ORDERS,
});
const failedOrdersSuccessAction = (data: any) => ({
  type: FailedOrders.FAILED_ORDERS_SUCCESS,
  payload: data,
});
const failedOrdersFailureAction = (data: any) => ({
  type: FailedOrders.FAILED_ORDERS_FAILURE,
  payload: data,
});
const clearFailedOrdersAction = () => ({
  type: FailedOrders.CLEAR_FAILED_ORDERS,
});
export function getFailedOrders(data?: GetOrdersRequestModel, role?: string) {
  let url = `/${
    role ? role.toLowerCase() : roleName().toLowerCase()
  }/deliveries/failed`;

  return (dispatch: any) => {
    dispatch(failedOrdersAction());
    HttpRequestPost(
      url,
      dispatch,
      failedOrdersSuccessAction,
      failedOrdersFailureAction,
      true,
      data || {
        Query: "",
        Filter: { Status: [] },
        OrderBy: "desc",
      },
      () => {}
    );
  };
}

export function clearFailedOrders() {
  return (dispatch: any) => {
    dispatch(clearFailedOrdersAction());
  };
}
